import { useState, useCallback } from 'react';

export function useAsyncFunctionProgress<TArgs extends any[], TResult>(
  asyncFunction: (...args: TArgs) => Promise<TResult>,
) {
  const [inProgress, setInProgress] = useState(false);

  const wrappedFunction = useCallback(
    async (...args: TArgs): Promise<TResult | null> => {
      setInProgress(true);
      try {
        return await asyncFunction(...args);
      } finally {
        setInProgress(false);
      }
    },
    [asyncFunction],
  );

  return {
    execute: wrappedFunction,
    inProgress,
  };
}
